export enum DatePresetOption {
  Day = "day",
  Week = "week",
  Month = "month",
  Season = "season",
  Period = "period",
}
